var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('slide-verify',{ref:"slideblock",attrs:{"slider-text":_vm.text,"imgs":_vm.imgs,"accuracy":_vm.accuracy},on:{"success":_vm.onSuccess,"again":_vm.onAgain,"fulfilled":_vm.onFulfilled,"fail":_vm.onFail,"refresh":_vm.onRefresh}}),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.msg))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f57634ea","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/slideVerify/index.vue
// module id = null
// module chunks = 